import { css } from '@emotion/core'
import { colors, measures, zIndexes } from 'styles/variables'
import { px } from 'utils/styles'

const { unit } = measures

export const header = css`
  text-align: right;
`

export const dialogStyles = {
  content: {
    position: 'relative',
    minWidth: px(42 * unit),
    left: 'auto',
    right: 'auto',
    top: 'none',
    bottom: 'none',
    textAlign: 'center',
  },

  overlay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.black60,
    zIndex: zIndexes.overlay,
  },
}
